/**
 * MobileScoutingHeader View Component
 *
 * Displays the Gemini logo on the left and activity/menu popover
 * buttons on the right for the mobile scouting screen header.
 * @module features/scouting/components/MobileScoutingHeader/MobileScoutingHeaderView
 */

import React, { memo } from "react";

import { Stack } from "@/components/atoms/Stack";
import { Icon } from "@/components/atoms/Icon";
import { LogoIcon } from "@/components/molecules/icons";

/** Props for MobileScoutingHeaderView */
interface MobileScoutingHeaderViewProps {
  /** Pre-rendered activity popover with custom circular trigger */
  readonly activityPopover: React.ReactNode;
  /** Pre-rendered menu popover with custom circular trigger */
  readonly menuPopover: React.ReactNode;
}

/**
 * Renders the mobile scouting header bar with logo and action buttons.
 * @param root0 - Component props
 * @param root0.activityPopover - Pre-rendered activity popover node
 * @param root0.menuPopover - Pre-rendered menu popover node
 */
const MobileScoutingHeaderView = ({
  activityPopover,
  menuPopover,
}: MobileScoutingHeaderViewProps) => (
  <Stack
    direction="horizontal"
    className="h-14 items-center justify-between bg-surface-base px-4"
  >
    <Icon as={LogoIcon} size="xl" />
    <Stack direction="horizontal" className="items-center gap-3">
      {activityPopover}
      {menuPopover}
    </Stack>
  </Stack>
);

MobileScoutingHeaderView.displayName = "MobileScoutingHeaderView";

export default memo(MobileScoutingHeaderView);
